import { Button, Form, Image } from "antd";
import { useEffect, useState } from "react";
import { openNotification } from "../../../Components/Notification";
import AuthService from "../../../Service/auth.service";
import { useNavigate } from "react-router-dom";
import { UserProvider } from "../../../Entities/UserProvider";
import useUserProvider from "../../../Hooks/useUserProvider";
import SyncWithGoogleCalendar from "./SyncWithGoogleCalendar";

interface Props {
  onGoogleSignIn: (success: boolean) => void;
  userProviders: UserProvider | null;
}

const LinkToGoogleCalendar: React.FC<Props> = ({
  onGoogleSignIn,
  userProviders,
}) => {
  const { userProvider } = useUserProvider();
  const [form] = Form.useForm();
  const [linkToGoogle, setLinkToGoogle] = useState<boolean>(false);
  const navigate = useNavigate();
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);

  const APIBaseUrl = process.env.REACT_APP_API_BASE_URL || "";

  useEffect(() => {
    if (userProvider?.providerCredentials?.token) {
      setLinkToGoogle(true);
      form.setFieldsValue({ linkToGoogleCalendar: true });
    } else {
      form.setFieldsValue({ linkToGoogleCalendar: false });
      setLinkToGoogle(false);
    }
  }, [userProvider]);

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const authSuccessParam = query.get("authSuccess");
    // if (userProviders?.providerCredentials?.token) {
    //   setLinkToGoogle(true);
    //   form.setFieldsValue({ linkToGoogleCalendar: true });
    // }
    if (authSuccessParam === "true") {
      setLinkToGoogle(true);
      onGoogleSignIn(true);
      form.setFieldsValue({ linkToGoogleCalendar: true });
      openNotification(
        "success",
        "Google Calendar",
        "Successfully linked Google Calendar."
      );
    } else if (authSuccessParam === "false") {
      onGoogleSignIn(false);
      openNotification("error", "Google Calendar", "Failed to link Calendar.");
    }
  }, []);

  const handleClick = async () => {
    try {
      if (linkToGoogle) {
        //make api call to backend for unlinking the calendar i.e. deleting the token from db
        const response = await AuthService.getInstance().unlinkCalendar();
        if (response.status === 200) {
          setLinkToGoogle(false);
          onGoogleSignIn(false);
          form.setFieldsValue({ linkToGoogleCalendar: false });

          const searchParams = new URLSearchParams(window.location.search);
          searchParams.set("authSuccess", "false");
          navigate(`?${searchParams.toString()}`, { replace: true });
          openNotification(
            "success",
            "Google Calendar",
            "Successfully unlinked Google Calendar."
          );
          setIsButtonDisabled(true);
          setTimeout(() => {
            setIsButtonDisabled(false);
          }, 2 * 1000);
        } else {
          openNotification(
            "error",
            "Google Calendar",
            "Could not unlink Google Calendar."
          );
        }
      } else {
        window.location.href = `${APIBaseUrl}/calendar/auth`;
      }
    } catch (error) {
      openNotification("error", "Google Calendar", "Failed to link Calendar.");
      console.error("Error during Google Calendar linking", error);
    }
  };

  return (
    <section className="link-to-google-calendar-section">
      {userProviders && <SyncWithGoogleCalendar />}
      <Button
        type="primary"
        disabled={isButtonDisabled}
        icon={
          <Image
            preview={false}
            src="/images/google-logo.png"
            width={20}
            height="auto"
          />
        }
        onClick={handleClick}
      >
        {linkToGoogle ? "Unlink" : "Connect With Google Calendar"}
      </Button>
    </section>
  );
};

export default LinkToGoogleCalendar;
